import { useQuery } from '@tanstack/react-query';
import { Link } from 'wouter';
import type { HomeGame } from '@/types/game';
import { fetcher } from '@/lib/queryClient';
import { GameCarousel } from '@/components/games/game-carousel';
import { NewGamesCarousel } from '@/components/NewGamesCarousel';
import { ChangePasswordDialog } from './change-password-dialog';
import { useCssVariable } from '@/hooks/use-css-variable';

export function Profile() {
  useCssVariable('--main-container-max-width', '100%', { removeOnUnmount: true });

  const { data: purchasedGames = [] } = useQuery<HomeGame[]>({
    queryKey: ['/api/user/games'],
    queryFn: fetcher,
  });

  const { data: allGames = [] } = useQuery<HomeGame[]>({
    queryKey: ['/api/games'],
    queryFn: fetcher,
  });

  const randomGames = [...allGames]
    .sort(() => Math.random() - 0.5)
    .slice(0, 7)
    .filter((game) => !purchasedGames.some((pg) => pg.id === game.id));

  return (
    <div className="main-container gap-8">
      <div className="flex justify-end mb-5">
        <ChangePasswordDialog />
      </div>
      <section className="flex flex-col gap-8 md:gap-14">
        {purchasedGames.length > 0 ? (
          <GameCarousel title={'Ваши игры'} games={purchasedGames} disableNavigation />
        ) : (
          <div className="text-center py-8">
            <p className="text-lg text-muted-foreground">
              Вы пока не купили ни одной игры. Посмотрите в{' '}
              <Link href="/games" className="text-primary hover:underline">
                каталоге
              </Link>{' '}
              или вот что мы вам рекомендуем:
            </p>
          </div>
        )}
        <NewGamesCarousel />
        <GameCarousel title="Случайные игры" games={randomGames} disableNavigation />
      </section>
    </div>
  );
}
